import { useQuery } from '@tanstack/react-query';
import { getIaqSystem } from '@/api/iaq';
import type { IaqFilters, IaqSystemResponseData } from '@/api/iaq/types';

/**
 * React Query hook for fetching IAQ subsystem data
 * Handles error cases and ensures we never return undefined
 */
export function useIaq(filters?: IaqFilters) {
  return useQuery<IaqSystemResponseData, Error>({
    queryKey: ['iaq', filters],
    queryFn: async () => {
      try {
        return await getIaqSystem(filters);
      } catch (error) {
        console.error('Error in useIaq hook:', error);
        throw error;
      }
    },
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: (failureCount, error) => {
      // Only retry network errors, not 4xx errors
      if (error.status && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}